import * as yup from 'yup'
import set from 'lodash/set'
import toPath from 'lodash/toPath'
import cloneDeep from 'lodash/cloneDeep'
import isInteger from 'lodash/isInteger'
import * as transltationService from '../../services/translationService'

const getTranslateString = key => {
  switch (key) {
    case 'custom.uniqueness':
      return transltationService.t('intake.validation.unique.email')
    default:
      return undefined
  }
}
//TODO: quick her do this
export const serverSideError = (serverError, mapping) => {
  if (!(serverError && serverError.details)) {
    return undefined
  }
  const { details = {} } = serverError
  const { codes = {} } = details
  let mappedErrors = {}

  const keys = Object.keys(codes)
  for (const key of keys) {
    const value = codes[key]
    mappedErrors[mapping[key]] = getTranslateString(value[0])
  }

  return mappedErrors
}

const mapObjectErrors = (validation, err) => {
  let mappedErrors = {}
  const fields = validation.map(validate => validate.id)

  fields.forEach(path => {
    const foundError = err.inner.find(errItem => {
      return errItem.path === path
    })
    if (foundError) {
      mappedErrors[path] = foundError.message
    }
  })
  return mappedErrors
}

const mapObjectBetterErrors = (validation, err) => {
  let mappedErrors = {}
  err.inner.forEach(error => {
    set(mappedErrors, error.path, error.message)
  })
  return mappedErrors
}

export default function(validation, state) {
  const yupInformation = validation.map(rule => ({
    [rule.id]: rule.validation,
  }))
  const schema = Object.assign(...yupInformation)
  var validationschema = yup.object(schema)
  return new Promise((resolve, reject) => {
    if (Array.isArray(state)) {
      let hasError = false
      let d = state.map(obj => {
        let newObj = {}
        try {
          validationschema.validateSync(obj, {
            abortEarly: false,
          })
        } catch (err) {
          hasError = true
          newObj = mapObjectBetterErrors(validation, err)
        }
        return newObj
      })
      if (hasError) {
        reject(d)
      } else {
        resolve(d)
      }
    } else {
      validationschema
        .validate(state, {
          abortEarly: false,
        })
        .then(resolve)
        .catch(err => {
          reject(mapObjectErrors(validation, err))
        })
    }
  })
}

export function yupToFormErrors(yupError) {
  let errors = {}
  for (let err of yupError.inner) {
    if (!errors[err.path]) {
      errors = setIn(errors, err.path, err.message)
    }
  }
  return errors
}

export function getIn(obj, key, def, p = 0) {
  const path = toPath(key)
  while (obj && p < path.length) {
    obj = obj[path[p++]]
  }
  return obj === undefined ? def : obj
}

function setIn(obj, path, value) {
  let res = {}
  let resVal = res
  let i = 0
  let pathArray = toPath(path)

  for (; i < pathArray.length - 1; i++) {
    const currentPath = pathArray[i]
    let currentObj = getIn(obj, pathArray.slice(0, i + 1))

    if (resVal[currentPath]) {
      resVal = resVal[currentPath]
    } else if (currentObj) {
      resVal = resVal[currentPath] = cloneDeep(currentObj)
    } else {
      const nextPath = pathArray[i + 1]
      resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {}
    }
  }

  if (value === undefined) {
    delete resVal[pathArray[i]]
  } else {
    resVal[pathArray[i]] = value
  }

  const result = { ...obj, ...res }

  // If the path array has a single element, the loop did not run.
  // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.
  if (i === 0 && value === undefined) {
    delete result[pathArray[i]]
  }

  return result
}



// WEBPACK FOOTER //
// ./src/components/Validator/index.js